<ng-container *transloco="let t">
  <div class="step-container">
    <div class="step-content">
      @if (loading) {
        <!-- Shimmer Loading State -->
        <div class="pending-shimmer">
          <div class="shimmer-icon-container"></div>
          <div class="shimmer-title"></div>
          <div class="shimmer-description"></div>
          <div class="shimmer-cards">
            @for (item of shimmerItems; track item) {
              <div class="shimmer-card">
                <div class="shimmer-card-icon"></div>
                <div class="shimmer-card-content">
                  <div class="shimmer-card-title"></div>
                  <div class="shimmer-card-text"></div>
                </div>
              </div>
            }
          </div>
        </div>
      } @else {
        <!-- Back Button -->
        <button class="back-button" (click)="onBack()" type="button">
          <mzic-svg src="assets/icons/arrow-left-disabled.svg" />
        </button>

        <!-- Success Icon - Plain icon like cashout-success-dialog -->
        <div class="success-icon-container">
          <mzic-svg src="assets/icons/mzic-success-icon.svg" />
        </div>

        <!-- Title -->
        <h1 class="success-title">{{ t('lang.pending_shares_title') }}</h1>

        <!-- Description -->
        <p class="success-description">
          {{
            t(pendingSharesDescriptionKey, {
              partner: partnerName,
              entity: integrationEntityName,
            })
          }}
        </p>

        <!-- Shares List -->
        @if (shares.length > 0) {
          <div class="shares-list">
            <h3 class="section-title">{{ t('lang.pending_shares_list_title') }}</h3>
            @for (share of shares; track share.id) {
              <div class="share-card">
                <div class="share-info-wrapper">
                  <div class="share-icon">
                    <mzic-svg src="assets/icons/mzic-cloud-upload-outline.svg" />
                  </div>
                  <div class="share-details">
                    <p class="share-type">{{ getTargetDisplayName(share) }}</p>
                    <p class="share-meta">
                      {{ t('lang.pending_shares_expires') }} {{ formatDate(share.expires_at) }}
                    </p>
                  </div>
                </div>
                <button
                  class="info-button"
                  (click)="onShareInfoClick(share)"
                  type="button">
                  <mzic-svg src="assets/icons/mzic-info.svg" />
                </button>
              </div>
            }
          </div>
        } @else {
          <div class="empty-state">
            <p>{{ t('lang.pending_shares_empty') }}</p>
          </div>
        }

        <!-- Info Section - Using share-section pattern from file-upload-step -->
        <div class="info-section">
          <p class="info-text">{{ t('lang.pending_shares_info') }}</p>
        </div>
      }
    </div>
  </div>

  <!-- Share Info Dialog -->
  @if (showShareInfoDialog() && selectedShare()) {
    <lib-share-info-dialog
      mode="info"
      [shareUrl]="getShareUrl()"
      [passcode]="selectedShare()!.passcode ?? ''"
      [expiresAt]="selectedShare()!.expires_at ?? ''"
      [shareId]="selectedShare()!.id"
      [revoking]="loading"
      [integrationEnabled]="integrationEnabled"
      [integrationEntityName]="integrationEntityName"
      (closeRequested)="onShareInfoClose()"
      (revoke)="onShareRevokeRequested($event)">
    </lib-share-info-dialog>
  }

  <!-- Toast -->
  @if (toastVisible()) {
    <mzic-toast
      [message]="toastMessage()"
      [state]="toastState()"
      (dismiss)="dismissToast()">
    </mzic-toast>
  }
</ng-container>
